// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const araquanid: PokeData = {
  "id": 752,
  "name": "araquanid",
  "height": 18,
  "weight": 820,
  "base_experience": 159,
  "types": [
    PokeType.WATER,
    PokeType.BUG
  ],
  "api_moves": [
    "headbutt",
    "bite",
    "water-gun",
    "bubble-beam",
    "leech-life",
    "bubble",
    "spider-web",
    "crunch",
    "mirror-coat",
    "aqua-ring",
    "bug-bite",
    "wide-guard",
    "soak",
    "entrainment",
    "infestation",
    "lunge",
    "liquidation"
  ],
  "moves": [
    "headbutt",
    "bite",
    "bubble-beam",
    "bubble",
    "crunch",
    "bug-bite",
    "lunge",
    "liquidation",
    "aqua-jet",
    "pounce",
    "rain-dance",
    "bug-buzz",
    "whirlpool"
  ],
  "evolution_chain": {
    "id": 387,
    "item": null,
    "species": [
      {
        "name": "dewpider",
        "order": 751,
        "types": [
          PokeType.WATER,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "araquanid",
        "order": 752,
        "types": [
          PokeType.WATER,
          PokeType.BUG
        ],
        "evolves_from_species_id": 751,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 178,
    "speed": 83,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
